module.exports = __webpack_public_path__ + "media/buzzer_eat-in.05486354.webm";